import { createContext } from "react";

export const TrimContext = createContext<Date | null>(null)